// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {buildPayload} from '../services/pip-code-request-build-payload';
import {getFileName} from '../../../shared/services/get-file-name';
import {getPipCodeRequests} from '../../shared/repositories';
import {getUser} from '../../../shared/services/get-user';
import {openFile} from '../../../shared/services/open-file';

export const readPipCodeRequests = selectedAccounts =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const payload = buildPayload(selectedAccounts);

        try {

            const data = await getPipCodeRequests(payload);

            dispatch({
                data,
                type: actions.UPDATE_TCSM_PIP_CODE_REQUESTS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const exportPipCodeRequests = () =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const {wipFacets} = getState().tcsm.wip;
        const payload = buildPayload(wipFacets.dealers, 'EXCEL', getUser().getLocale(), 'PipCodeStatusUpdate');

        try {

            const response = await getPipCodeRequests(payload);
            const fileName = getFileName(response);
            const blob = await response.blob();

            openFile(blob, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/get-pip-code-requests.js